import { Flex, IconMsExcelLine, IconZippedLine, Link } from "@instructure/ui";

const CustomDownloadRenderer = ({ mainState: { currentDocument } }) => {
  if (!currentDocument) return null;

  return (
    <Flex height="30rem" justifyItems="center">
      <Flex.Item textAlign="center">
        <Link
          href={currentDocument.uri}
          renderIcon={
            currentDocument.fileType === "zip" ? (
              <IconZippedLine size="small" />
            ) : (
              <IconMsExcelLine size="small" />
            )
          }
        >
          {currentDocument.fileName}
        </Link>
      </Flex.Item>
    </Flex>
  );
};

CustomDownloadRenderer.fileTypes = ["zip", "xls", "xlsx"];
CustomDownloadRenderer.weight = 1;

export default CustomDownloadRenderer;
